import React, { useState } from 'react'
import { Box, MenuItem, TextField, Typography } from '@mui/material'
import { chunks } from '../../../../utils'

interface Props {
  register: any
  title: string
  dropdownTitle: string
  entries: [string, string][]
  translation: { [key: string]: string }
  attr_name: string
  errors: any
  numberOnly?: boolean
}

export const DamageAttributes: React.FC<Props> = ({
  title,
  dropdownTitle,
  entries,
  attr_name,
  translation,
  register,
  errors,
  numberOnly = false,
}) => {
  const [damages, setDamages] = useState<[string, string][]>(
    entries.filter(s => s[1] !== '').filter(s => s[0] !== 'id')
  )

  return (
    <Box sx={{ marginBottom: '8px' }}>
      <Typography variant="button" display="block" gutterBottom>
        {title}
      </Typography>

      {damages.length < Object.keys(translation).length && (
        <Box sx={{ display: 'flex', marginBottom: '8px', marginLeft: '4px', marginRight: '4px' }}>
          <TextField
            select
            fullWidth={true}
            label={dropdownTitle}
            value=""
            onChange={e => {
              e.preventDefault()
              setDamages(prevState => {
                if (!prevState.map(s => s[0]).includes(e.target.value)) {
                  return [[e.target.value, '1d6'], ...prevState]
                }
                return [...prevState]
              })
            }}
          >
            {Object.entries(translation)
              .filter(dmg => !damages.map(s => s[0]).includes(dmg[0]))
              .map(dmg => (
                <MenuItem key={dmg[0]} value={dmg[0]}>
                  {dmg[1]}
                </MenuItem>
              ))}
          </TextField>
        </Box>
      )}

      {damages &&
        chunks(damages.sort(), 4).map((group: [string, string][]) => (
          <Box key={JSON.stringify(group)} sx={{ display: 'flex', marginBottom: '8px' }}>
            {group.map(dmg => (
              <TextField
                key={`${attr_name}_attributes.${dmg[0]}`}
                sx={{ marginRight: '4px', marginLeft: '4px' }}
                fullWidth={true}
                name={`${attr_name}_attributes.${dmg[0]}`}
                defaultValue={dmg[1]}
                label={translation[dmg[0]] || dmg[0]}
                variant="outlined"
                type={numberOnly ? 'number' : 'text'}
                inputProps={{
                  ref: register({
                    pattern: numberOnly ? /^\d+$/ : /^\d+(:?d\d+)*(:?\+\d+)*$/,
                  }),
                }}
                onBlur={e =>
                  setDamages(prevState => [
                    ...prevState.filter(s => s[0] !== dmg[0]),
                    [dmg[0], e.target.value],
                  ])
                }
                error={hasError(errors, attr_name, dmg[0])}
                helperText={
                  hasError(errors, attr_name, dmg[0]) &&
                  (numberOnly ? 'Tylko liczby' : 'Wymagana liczba lub format kostki, np: 1d6+1')
                }
              />
            ))}
          </Box>
        ))}
    </Box>
  )
}

const hasError = (errors: any, attr_name: string, dmg: string) => {
  const attr = attr_name.substring(attr_name.indexOf('.') + 1, attr_name.length) + '_attributes'

  return !!(
    errors['effect_attributes'] &&
    errors['effect_attributes'][attr] &&
    errors['effect_attributes'][attr][dmg]
  )
}
